import Axios from "axios";
import {
  GET_CALENDAR,
  POST_CALENDAR,
  LOADING_CALENDAR,
  GET_ERRORS
} from "./types";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

const error = () => {
  if(!document.getElementById("calendar-e")) return;
  document.getElementById("calendar-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("calendar-e").style.display = "none"),
    5000
  );
};

export const postCalendar = storeData => dispatch => {
  dispatch(setCalendarLoading());
  Axios.post("/api/v1/calendars", storeData)
    .then(res => {
      dispatch({
        type: POST_CALENDAR,
        payload: storeData
      });
    })
    .catch(err => {
      console.log(err);
      error();
    });
};

export const getCalendar = () => dispatch => {
  dispatch(setCalendarLoading());
  Axios.get("/api/v1/calendars")
    .then(res => {
      dispatch({
        type: GET_CALENDAR,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
};


export const setCalendarLoading = () => {
  return {
    type: LOADING_CALENDAR
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
